import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { DAILY_USES, PRO_USES } from "@/data/content";

const Grid = ({ items }) => (
  <div className="grid gap-5 sm:grid-cols-2">
    {items.map((item, i) => {
      const Icon = Icons[item.icon] || Icons.Sparkles;
      return (
        <motion.div
          key={item.title}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45, delay: i * 0.07 }}
          className="flex gap-4 rounded-2xl border border-white/10 bg-white/5 p-6 transition-colors hover:border-primary/50 hover:bg-white/10"
        >
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary/20 text-primary">
            <Icon className="h-6 w-6" />
          </span>
          <div>
            <h3 className="font-display text-lg font-semibold text-white">{item.title}</h3>
            <p className="mt-1 text-sm leading-relaxed text-white/60">{item.desc}</p>
          </div>
        </motion.div>
      );
    })}
  </div>
);

export const UseCases = () => {
  return (
    /* Dark charcoal section - like the screenshot */
    <section id="use-cases" className="relative overflow-hidden bg-[#1a1a2e] py-20 lg:py-28">
      {/* Subtle orange glow top-right */}
      <div className="pointer-events-none absolute -top-24 right-0 h-72 w-72 rounded-full bg-primary/10 blur-[80px]" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-primary/20 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-primary">
            Progress
          </span>
          <h2 className="section-title mt-4 text-white">
            Track Your Improvement
          </h2>
          <p className="mt-4 text-base text-white/60 md:text-lg">
            See your progress over time with our performance dashboard.
          </p>
        </div>

        <div className="mt-12">
          <Tabs defaultValue="daily" className="w-full">
            <div className="flex justify-center">
              <TabsList className="h-12 rounded-full bg-white/10 p-1 border border-white/10">
                <TabsTrigger
                  value="daily"
                  className="rounded-full px-6 text-sm text-white/70 data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:shadow"
                >
                  Preparation
                </TabsTrigger>
                <TabsTrigger
                  value="pro"
                  className="rounded-full px-6 text-sm text-white/70 data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:shadow"
                >
                  Execution
                </TabsTrigger>
              </TabsList>
            </div>
            <TabsContent value="daily" className="mt-10">
              <Grid items={DAILY_USES} />
            </TabsContent>
            <TabsContent value="pro" className="mt-10">
              <Grid items={PRO_USES} />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </section>
  );
};
